import { any, async, fromJSX, nothing } from "widgets-for-react";
import { managementApi } from "./ManagementApi";
import { ManagementLayout } from "./ManagementLayout";
import { initialManagementState } from "./ManagementState";
export const ManagementWidget = (props)=>{
    const api = managementApi();
    return any({
        key: `ManageLoginWidget`
    })([
        fromJSX((setState)=>{
            return ManagementLayout({
                ...props,
                updateStatus: (id, status)=>{
                    updateStatus(setState, api, id, status);
                },
                acceptAll: (ids)=>acceptAll(setState, api, ids)
            });
        }),
        async(nothing, {
            key: 'reactionsLoader'
        })(props.reactions).map((resultUpdater)=>(s1)=>{
                const reactions = resultUpdater(s1.reactions);
                return {
                    ...s1,
                    reactions
                };
            })
    ]).map((a)=>a(props));
};
const acceptAll = async (setState, api, ids)=>{
    setState((s0)=>({
            ...s0,
            submitting: true
        }));
    const message = await api.acceptAll(ids).then((result)=>{
        if (result.kind != 'result') throw result.kind;
        const m = {
            kind: "success",
            message: "Alle berichten zijn geaccepteerd."
        };
        return m;
    }).catch((e)=>{
        console.error('Failed to update status', e);
        const m = {
            kind: "error",
            message: "Er is iets verkeerd gegaan."
        };
        return m;
    });
    setState((s0)=>{
        const success = message.kind == 'success';
        const nextState = success ? initialManagementState(api) : s0;
        const { reactions } = nextState;
        return {
            ...s0,
            validationMessages: [
                message
            ],
            submitting: false,
            reactions
        };
    });
};
const updateStatus = async (setState, api, id, status)=>{
    setState((s0)=>({
            ...s0,
            submitting: true
        }));
    const message = await api.updateStatus(id, status).then((result)=>{
        if (result.kind != 'result') throw result.kind;
        const m = {
            kind: "success",
            message: "Het bericht is geupdate."
        };
        return m;
    }).catch((e)=>{
        console.error('Failed to update status', e);
        const m = {
            kind: "error",
            message: "Er is iets verkeerd gegaan."
        };
        return m;
    });
    setState((s0)=>{
        const success = message.kind == 'success';
        const nextState = success ? initialManagementState(api) : s0;
        const { reactions } = nextState;
        return {
            ...s0,
            validationMessages: [
                message
            ],
            submitting: false,
            reactions
        };
    });
};
